/*
  Project: ARCA
  Author: schrittweiter GmbH
 */

import './modules/lazy';
import './modules/slider';
import './modules/modal';
import './modules/trigger';
import './modules/appHeight';
import './modules/hyphen';
import './modules/accordion';
import './modules/location';
import './modules/scroll';
import './modules/video';
import './modules/nav';
import './modules/popup';
import './modules/form';
import './modules/quiz';
